import { takeLatest, put, call, select } from 'redux-saga/effects';
import {
  BankIDLoginActions,
  bankIDLoginFail,
  bankIDLoginGetCredentials,
  bankIDLoginInitSuccess,
  bankIDLoginSuccess
} from './actions';
import { checkAccountState, initiateBankIDLoginAPI } from './api';
import { BankIDOrderStatusActions } from 'services/auth/bank-id-order-status/actions';
import { loginWithBankIDAPI } from './api';
import { setAuthToken } from 'utils/auth-token';
import { AppTracking } from 'global/appTracking';

function* initBankIDLoginEffect({ payload }) {
  try {
    const { status } = yield call(checkAccountState, payload);

    if (status === 'reset_required') {
      window.location = '/activate-account';
    } else if (status !== 'confirmed') {
      yield put(bankIDLoginFail('bankIDPersonalNumberUnknown'));
    } else {
      const initLogin = yield call(initiateBankIDLoginAPI, payload);
      yield put(bankIDLoginInitSuccess(initLogin.orderRef));
    }
  } catch (e) {
    if (e.statusCode === 404) {
      yield put(bankIDLoginFail('bankIDPersonalNumberUnknown'));
    } else {
      yield put(bankIDLoginFail(e.message));
    }
  }
}

function* bankIDLoginSuccessfulEffect({ payload }) {
  try {
    const { orderRef, personalNumber } = yield select(state => state.bankIDLogin);
    if (orderRef === payload.orderRef) {
      yield put(bankIDLoginGetCredentials());

      const { AuthenticationResult } = yield call(loginWithBankIDAPI, payload.response, personalNumber);
      setAuthToken(AuthenticationResult.IdToken, AuthenticationResult.AccessToken);

      yield put(bankIDLoginSuccess());
      AppTracking.authEvent({ action: 'Login', label: 'BankID' });
    }
  } catch (e) {
    yield put(bankIDLoginFail('genericErrorMessage'));
  }
}

function* bankIDLoginFailEffect({ payload }) {
  const orderRef = yield select(state => state.bankIDLogin.orderRef);
  if (orderRef === payload.orderRef) {
    yield put(bankIDLoginFail(payload.error));
  }
}

export const bankIDLoginEffects = [
  takeLatest(BankIDLoginActions.BANK_ID_LOGIN, initBankIDLoginEffect),
  takeLatest(BankIDOrderStatusActions.BANK_ID_ORDER_SUCCESSFUL, bankIDLoginSuccessfulEffect),
  takeLatest(BankIDOrderStatusActions.BANK_ID_ORDER_FAIL, bankIDLoginFailEffect),
];
